<template>
	<main class="bg_container" style="flex-wrap: wrap;">
		<div class="container tab-container pt-5">
			<div class="row align-items-center justify-content-between text-center category"
				v-for="(item, index) in stores.list" :key="index">
				<div class="col">
					<div class="icon-label tab" :class="{ active: activeTabIndex == index }" @click="setActive(index)">
						{{ item.name }}</div>
				</div>
			</div>
			<ul>
				<li v-for="aaa in stores.linkMan" :key="aaa.id">{{aaa.linkMan}}</li>
			</ul>
		</div>
		<div class="photo-group mt-4">
			<div class="photo-container" v-for="(item, index) in activeChildren" :key="index"
				@click="setActiveProduct(index)">
				<img class="default-img" :src="getProductImage(index)" alt="默认图片1" loading="lazy">
				<img class="hover-img" :src="item.childHoverImg" alt="悬浮图片1" loading="lazy">
				<div class="photo-title" :class="{ active: activeProductIndex == index }">{{ item.childName }}</div>
			</div>
		</div>

		<section class="pt-4 width_10" data-aos="fade-up" id="example-carousel">
			<div class="container carousel" style="z-index: 100;">
				<!-- 图片轮播项 -->
				<div class="carousel-wrapper">
					<div class="carousel-item" v-for="(item, index) in activeProduct" :key="index"
						:style="getStyle(index)">
						<img :src="getImage(index)" :alt="item.title" @click="goToSlide(index)" loading="lazy" />

					</div>
				</div>
			</div>
			<img class="base_img mb-4" src="../../assets/img/Main/base.png" loading="lazy" />

			<h3 class="h5 mt-3 mb-3 text-muted">{{dotProductCode}} </h3>
			<!-- <div class="row ">
				<div class="col">
					<button type="submit" class="btn custom-btn-primary ">Check It Out</button>
				</div>
			</div> -->
			<!-- 分页点 -->
			<div class="dots pb-5">
				<span v-for="(item, index) in activeProduct" :key="index"
					:class="['dot', { active: index === activeImgIndex }]" @click="goToSlide(index)"></span>
			</div>
		</section>
	</main>
</template>

<script>
	import {
		getCategoryList, getLinkMan1
	} from "@/api/rbac/main";

	import { getProductMain } from "@/api/rbac/product";
	export default {
		name: 'HomeSecond',
		data() {
			return {
				stores: {
					menu: {
						query: {
							totalCount: 0,
							pageSize: 20,
							currentPage: 1,
							kw: "",
							isDeleted: 0,
							status: -1,
							parentGuid: "",
							parentName: "请选择...",
							sort: [
								{
									direct: "DESC",
									field: "id",
								},
							],
						},
					},
					list: [],
					linkMan: [],
				},
				dotProductCode: '',
				activeImgIndex: 0, // 当前激活的图片索引
				activeProductIndex: 0,
				activeTabIndex: 0,

			};
		},
		computed: {
			activeChildren() {
				// 当前激活 Tab 的子项
				return this.stores.list[this.activeTabIndex]?.children || [];
			},
			activeProduct() {
				// 当前激活 Tab 的子项
				return this.stores.list[this.activeTabIndex]?.children[this.activeProductIndex].product || [];
			},
			totalCount() {
				return this.stores.list[this.activeTabIndex]?.children[this.activeProductIndex].product.length || 0;
			},
		},
		mounted() {
			this.loadMenuList()
			// this.loadLinkList()
		},
		methods: {
			loadMenuList() {
				getCategoryList().then((res) => {
					this.stores.list = res.data.data;
					this.dotProductCode = this.activeProduct[0]?.code || ''
					// this.dotProductCode=this.stores.list
					//this.stores.menu.query.totalCount = res.data.totalCount;
				});
			},
			loadLinkList() {
				getLinkMan1({ strEmail: "kamran@emperor-properties.com" }).then((res) => {
					this.stores.linkMan = res.data.data;
					// for (var item in this.stores.linkMan) {
					// 	alert(item.linkMan)
					// }
					// this.stores.menu.query.totalCount = res.data.totalCount;
				});
			},
			setActive(index) {
				this.activeTabIndex = index;
				this.activeProductIndex = 0;
				this.activeImgIndex = 0;
			},
			setActiveProduct(index) {
				this.activeProductIndex = index;
				this.activeImgIndex = 0;
			},
			goToSlide(index) {
				if (index == this.activeImgIndex) {
					//判断权限===============
					try {
						var strWhere = ' and a.ID=' + this.activeProduct[index].id
						if (this.user == null) {
							strWhere += ' and DATEDIFF(mm,happendate,getDate())>=(select MAX(intMonth) from WebUserLevelSet)'
						}
						else {
							// if (this.user.isCus == 1) {
							// 	strWhere += ` and DATEDIFF(mm,happenDate,GETDATE())>=${this.user.intMonth}`
							// }
							strWhere += ` and DATEDIFF(mm,happenDate,GETDATE())>=${this.user.intMonth}`
						}
						getProductMain({ strWhere: strWhere }).then(res => {
							this.totalData = res.data.length;
							if (res.data.length == 0) {
								return
							}
							else {
								this.$router.push({ name: 'product', params: { category: this.activeProduct[index].id, productsName: this.activeProduct[index].mainCodeID } })
							}
						})
					} catch (error) {
						console.error('获取失败:', error);
					}
				}
				this.dotProductCode = this.activeProduct[index].code;
				// 跳转到指定图片
				this.activeImgIndex = index;
			},
			getStyle(index) {
				// 动态设置每张图片的位置
				const total = this.activeProduct.length;
				const offset = index - this.activeImgIndex;

				// 确保循环索引始终正确（-1 = 最后一张，+1 = 下一张）
				const position = offset < 0 ? offset + total : offset % total;

				// 根据位置设置对应的样式
				if (position === 0) {
					return { transform: "translateX(0) scale(1.1)", zIndex: 10, opacity: 1, transition: "all opacity 5s linear" };
				} else if (position === 1) {
					return { transform: "translateX(360px) scale(0.5)", zIndex: 5, opacity: 0.5, transition: "all opacity 5s ease-in-out" };
				} else if (position === total - 1) {
					return { transform: "translateX(-360px) scale(0.5)", zIndex: 5, opacity: 0.5, transition: "all opacity 5s ease-in-out" };
				} else {
					return { display: "none" }; // 其他图片隐藏
				}
			},
			getProductImage(index) {
				// 动态设置每张图片的位置
				const total = this.activeChildren.length;
				const offset = index - this.activeProductIndex;
				// 确保循环索引始终正确（-1 = 最后一张，+1 = 下一张）
				const position = offset < 0 ? offset + total : offset % total;

				// 根据位置设置对应的样式
				if (position === 0) {
					return this.activeChildren[index].childHoverImg
				} else {
					return this.activeChildren[index].childImg
				}
			},
			getImage(index) {
				// 动态设置每张图片的位置
				const total = this.activeProduct.length;
				const offset = index - this.activeImgIndex;
				// 确保循环索引始终正确（-1 = 最后一张，+1 = 下一张）
				const position = offset < 0 ? offset + total : offset % total;

				// 根据位置设置对应的样式
				if (position === 0) {
					return this.activeProduct[index].imgBright
				} else {
					return this.activeProduct[index].img
				}
			},
		},
	};
</script>

<style scoped>
	@import '../../assets/css/main.css';

	:deep(body) {
		margin: 0;
		background-color: #333;
		color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
	}

	.bg_container {
		background-color: #252524;
		background-image: url('../../assets/img/SecondBg.png');
		/* 设置背景图片 */
		background-size: cover;
		/* 背景图片自适应容器 */
		background-position: center;
		/* 背景图片居中显示 */
		background-repeat: no-repeat;
		/* 不重复显示背景图片 */

		/* 3. 避免图片加载时闪烁 */
		background-blend-mode: normal;
		/* 4. 可选：延迟加载背景图（非首屏） */
		background-attachment: fixed;
	}

	:deep(.tab-container) {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	:deep(.category) {
		width: 15rem;
		line-height: 20px;
		color: #7F7F7F;
	}

	:deep(.tab) {
		flex: 1;
		padding: 10px;
		cursor: pointer;
		color: gray;
	}

	:deep(.tab.active) {
		font-size: 25px;
		color: #fff;
		line-height: 30px;
	}

	:deep(.tab.active::after) {
		content: '';
		display: block;
		width: 3.5rem;
		height: 0.25rem;
		background-color: #FCB42E;
		margin: 0.7rem auto 0;
	}

	:deep(.photo-group) {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
	}

	:deep(.photo-container) {
		text-align: center;
		position: relative;
		width: 12rem;
		height: 150px;
		cursor: pointer;
		display: flex;
		justify-content: center;
	}

	@media (max-width: 576px) {
		:deep(.photo-container) {
			width: 10rem;
		}
	}

	:deep(.photo-container:not(:last-child)::after) {
		content: "";
		position: absolute;
		top: 30%;
		bottom: 30%;
		right: 0;
		width: 1px;
		background-color: rgba(255, 255, 255, 0.3);
	}

	@media (max-width: 1200px) {
		:deep(.photo-container:not(:last-child)::after) {
			width: 0px;
		}
	}

	:deep(.photo-container img) {
		position: absolute;
		top: 0;
		width: 70%;
		height: 70%;
		object-fit: contain;
		transition: opacity 1s ease;
	}

	:deep(.photo-container img.default-img) {
		opacity: 1;
	}

	:deep(.photo-container img.hover-img) {
		opacity: 0;
	}

	/* 鼠标悬浮时切换图片 */
	:deep(.photo-container:hover img.default-img) {
		opacity: 0;
	}

	:deep(.photo-container:hover img.hover-img) {
		opacity: 1;
	}

	:deep(.photo-container .photo-title) {
		color: #FFF;
		transition: color 1s ease;
	}

	:deep(.photo-container:hover .photo-title) {
		color: #FCB42E;
	}

	:deep(.photo-title) {
		color: #fff;
		margin-top: 6.5rem;
		font-size: 14px;
	}

	:deep(.photo-title.active) {
		color: #FCB42E;
	}

	/* 文字样式 */
	:deep(.icon-label) {
		font-size: 14px;
		white-space: pre-line;
	}

	:deep(.carousel) {
		position: relative;
		width: 100%;
		height: 28rem;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	:deep(.carousel-wrapper) {
		position: relative;
		width: 400px;
		height: 28rem;
		display: flex;
		justify-content: center;
		align-items: center;
		perspective: 1000px;
	}

	:deep(.carousel-item) {
		position: absolute;
		width: 400px;
		height: 28rem;
		transition: transform 0.5s ease, z-index 0.5s ease;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
	}

	:deep(.carousel-item img) {
		width: 100%;
		height: auto;
	}

	:deep(.base_img) {
		width: 40rem;
		margin-top: -3rem;
	}

	/* 响应式调整 */
	@media (max-width: 768px) {
		:deep(.carousel-wrapper) {
			width: 90%;
			/* 小屏时增加容器宽度 */
		}

		:deep(.carousel-item) {
			max-width: 300px;
			/* 减少最大宽度 */
		}

		:deep(.base_img) {
			width: 35rem;
			margin-top: -8rem;
		}
	}

	@media (max-width: 480px) {
		:deep(.carousel-wrapper) {
			width: 100%;
		}
	}
</style>